import "./editIFrame.scss";

import TextInput from "../../components/textInput/TextInput";
import YellowButton from "../../components/buttons/defaultButton/yellowButton/YellowButton";
import WhiteButton from "../../components/buttons/defaultButton/whiteButton/WhiteButton";
import Select from "../../components/select/Select";

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { baseUrl, useGetPageQuery, useSendFormMutation } from "../../redux/services/velmartAPI";
import { getIFrameById } from "../../components/iFrameFields/iFrameListData";
import { ErrorHandler } from "../../helpers/ErrorHandler";
import FrameListModal from "../../components/modals/frameListModal/FrameListModal";
import { succsesDataChangeAlert } from "../../alerts/alerts";

const EditIFrame = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [departmentId, setDepartmentId] = useState(0);
    const [designId, setDesignId] = useState(0);
    const [equipmentId, setEquipmentId] = useState(0);
    const [ifremesList, setIframeList] = useState([]);
    const [iFrameCount, setIframeCount] = useState([0]);
    const [selectedIFrameIndex, setSelectedIFrameIndex] = useState(0);

    const [currentSelectingImage, setCurrentSelectingImage] = useState(null);
    const [selectedImages, setSelectedImages] = useState({});

    const [showFrameModal, setShowFrameModal] = useState(false);

    const { data: equipments } = useGetPageQuery("equipments?per_page=0");
    const { data: designs } = useGetPageQuery("designs?per_page=0");
    const { data: departments } = useGetPageQuery("departments?per_page=0");
    const { data: file } = useGetPageQuery("files/" + id);
    const [sendForm, { error, isError, isSuccess, data: sendFormData }] = useSendFormMutation();

    const addImageHandler = (id) => {
        setCurrentSelectingImage(id);
        window.open(baseUrl + "api/laravel-filemanager?type=image", "FileManager", "width=900,height=600");
    };

    useEffect(() => {
        if (file) {
            setDepartmentId(file.department_id);
            setDesignId(file.design_id);
            setEquipmentId(file.equipment_id);
        }
    }, [file]);

    const updateIFrameHandler = async () => {
        const formData = {
            design_id: designId,
            department_id: departmentId,
            equipment_id: equipmentId,
            iframes: ifremesList,
        };

        try {
            await sendForm({ url: "files/" + id, body: formData, method: "PUT" }).unwrap();
            navigate("/files/edit/" + (+id + 1));
        } catch (error) {
            ErrorHandler(error, navigate);
        }

        if (!isError) {
            succsesDataChangeAlert();
        }
    };

    useEffect(() => {
        function eventHandler(event) {
            if (event?.data?.type === "lfm") {
                const imgUrl = event.data.images[0].url;
                setSelectedImages({
                    ...selectedImages,
                    [currentSelectingImage]: { url: imgUrl, status: true, subtitle: "" },
                });
            }
        }
        window.addEventListener("message", eventHandler);

        return () => {
            window.removeEventListener("message", eventHandler);
        };
    });

    const changeImgStatus = (key, status) => {
        setSelectedImages((prev) => ({ ...prev, [key]: { ...prev[key], status: status } }));
    };
    const changeImgSubtitle = (key, subtitle) => {
        setSelectedImages((prev) => ({ ...prev, [key]: { ...prev[key], subtitle: subtitle } }));
    };

    const addIFrameHandler = () => {
        setIframeCount([...iFrameCount, 0]);
    };

    // useEffect(() => {
    //     if (file) {
    //         const imagesList = {};
    //         const iframeList = []
    //         file.iframes.forEach((iframe, index) => {
    //             setIframeCount([...Array(file.iframes.length).keys()]);
    //             for (let key in iframe.fields) {
    //                 if (iframe.fields[key].type === "image") {
    //                     imagesList[iframe.fields[key].id] = iframe.fields[key].content;
    //                 }
    //             }
    //         });
    //         setSelectedImages(imagesList);
    //     }
    // }, [file]);

    useEffect(() => {
        if (file) {
            const imagesList = {};
            const iframeList = [];
            file.iframes.forEach((iframe, index) => {
                iframeList.push(iframe.id);
                for (let key in iframe.fields) {
                    if (iframe.fields[key].type === "image") {
                        imagesList[iframe.fields[key].id] = iframe.fields[key].content;
                    }
                }
            });
            setSelectedImages(imagesList);
            setIframeCount(iframeList);
        }
    }, [file]);

    const onChangeIframe = (index) => {
        setSelectedIFrameIndex(index);
        setShowFrameModal(true);
    };

    return (
        <>
            {equipments && designs && departments && file && (
                <div className="page-content__container">
                    <FrameListModal
                        isOpen={showFrameModal}
                        btnTitle={"Обрати файл"}
                        setIsOpen={setShowFrameModal}
                        selectedIFrameIndex={selectedIFrameIndex}
                        setIframeCount={setIframeCount}
                    />
                    <div className="create-iframe">
                        <div className="create-iframe__view">
                            <div className="input-lable">Вид iframe</div>
                            {/* <TextInput inputValue={"Frame " + file?.iframes[0]?.id} isDisabled={true} /> */}
                            {/* <div className="create-iframe__view-button">
                                <YellowButton
                                    text={"Змінити фрейм"}
                                    font={"14px"}
                                    padding={"12px 24px"}
                                    onClick={() => setShowFrameModal(true)}
                                />
                            </div> */}
                        </div>
                        <div className="create-iframe__param">
                            <div className="input-lable">Відділ</div>
                            <Select
                                title={"Оберість відділ"}
                                padding={"15px 20px"}
                                listData={departments}
                                setValue={setDepartmentId}
                                selectedTitle={file?.department?.title}
                            />
                        </div>
                        <div className="create-iframe__param">
                            <div className="input-lable">Обладнання</div>
                            <Select
                                title={"Оберість обладнання"}
                                padding={"15px 20px"}
                                listData={equipments}
                                setValue={setEquipmentId}
                                selectedTitle={file?.equipment?.title}
                            />
                        </div>
                        <div className="create-iframe__param">
                            <div className="input-lable">Рекламні матеріали</div>
                            <Select
                                title={"Оберість рекламні матеріали"}
                                padding={"15px 20px"}
                                listData={designs}
                                setValue={setDesignId}
                                selectedTitle={file?.design?.title}
                            />
                        </div>
                        {iFrameCount.map((countValue, index) => {
                            return (
                                <>
                                    <div className="frame-devider">
                                        <div className="frame-devider__title">Фрейм №{index + 1}</div>
                                    </div>

                                    <div className="create-iframe__view">
                                        <div className="input-lable">Вид iframe</div>
                                        <TextInput
                                            inputValue={"Frame " + `${!!countValue ? countValue : "не обрано"}`}
                                        />
                                        <div className="create-iframe__view-button">
                                            <YellowButton
                                                text={"Обрати фрейм"}
                                                font={"14px"}
                                                padding={"12px 24px"}
                                                onClick={() => onChangeIframe(index)}
                                            />
                                        </div>
                                    </div>

                                    {!!countValue &&
                                        getIFrameById(
                                            countValue,
                                            addImageHandler,
                                            selectedImages,
                                            changeImgStatus,
                                            changeImgSubtitle,
                                            setIframeList,
                                            index,
                                            file.iframes[index]
                                        )}
                                </>
                            );
                        })}
                    </div>
                    <div className="bottom-buttons">
                        <div className="bottom-buttons__left">
                            <WhiteButton
                                text={"Передпоказ фрейму"}
                                padding={"14px 36px"}
                                font={"16px"}
                                width={"max-content"}
                            />
                            <YellowButton
                                text={"Зберегти фрейм"}
                                padding={"14px 36px"}
                                font={"16px"}
                                onClick={updateIFrameHandler}
                            />
                        </div>
                        <div className="bottom-buttons__right" onClick={addIFrameHandler}>
                            Створити ще один фрейм +
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default EditIFrame;
